import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import LanguageSwitcher from '../common/LanguageSwitcher';
import HelpButton from '../common/HelpButton';
import './Homepage.css';
import backgroundImage from '../../assets/common/background_homepage.png';
import welcomeImage from '../../assets/get_started/welcome_image.png';
import buttonBgImage from '../../assets/get_started/get_started_button.png';
import accessibilityIcon from '../../assets/common/accessablity_icon.png';
import slavexLogoNoText from '../../assets/get_started/logo_without_text.png';

function Homepage() {
  const navigate = useNavigate();
  const { currentUser, userRoles, loading: authLoading } = useAuth();
  const { t, isRTL } = useLanguage();

  // Get build number for cache busting
  const buildNumber = process.env.REACT_APP_BUILD_NUMBER || Date.now();

  // Redirect logged in users to dashboard if they have roles, or login if they don't
  useEffect(() => {
    if (authLoading) return;

    if (currentUser) {
      if (userRoles && userRoles.length > 0) {
        // Only redirect if user is approved (check happens in App.js routing)
        // Don't redirect here to avoid loops - let App.js handle it
        // navigate('/jobs');
      } else {
        // User logged in but no roles, go to login to select role
        navigate('/auth-choice');
      }
    }
  }, [currentUser, userRoles, authLoading, navigate]);

  const handleGetStarted = () => {
    navigate('/auth-choice');
  };

  const handleTermsClick = (e) => {
    e.preventDefault();
    navigate('/terms');
  };

  return (
    <div className={`homepage ${isRTL ? 'rtl' : ''}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="welcome-frame" role="main" aria-label="Welcome">
        {/* Background */}
        <div
          className="welcome-bg"
          aria-hidden="true"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        />

        {/* Language Switcher (Top Left) */}
        <div className="language-switcher-wrapper">
          <LanguageSwitcher variant="welcome" />
        </div>

        {/* Accessibility Button (Top Right) */}
        <button
          type="button"
          className="accessibility-button"
          aria-label={t('homepage.accessibility') || 'Accessibility'}
          onClick={() => {
            // TODO: Implement accessibility features
            console.log('Accessibility button clicked');
          }}
        >
          <img
            src={accessibilityIcon}
            alt=""
            className="accessibility-icon"
            aria-hidden="true"
          />
        </button>

        {/* Main centered layout (responsive on iPhone + desktop) */}
        <div className="welcome-layout">
          <div className="welcome-main">
            {/* Logo Container */}
            <div className="logo-container">
              <img src={slavexLogoNoText} alt={t('app.name')} className="logo-img" />
            </div>

            {/* Welcome Text */}
            <div className="welcome-text-container">
              <img
                src={welcomeImage}
                alt="Welcome"
                className="welcome-image"
              />
              {/* <h1 className="welcome-text">{t('homepage.welcome')}</h1> */}
            </div>
          </div>

          <div className="welcome-actions">
            {/* Let's Start Button */}
            <button type="button" className="lets-start-button" onClick={handleGetStarted}>
              <div className="button-bg">
                <img src={buttonBgImage} alt="" className="button-bg-img" />
              </div>
              <span className="lets-start-text">{t('homepage.letsStart')}</span>
            </button>

            {/* Terms & Conditions Link */}
            <a
              href="#terms"
              className="terms-link"
              onClick={handleTermsClick}
            >
              <span className="terms-link-text">
                {t('homepage.termsConditions') || 'Terms & Conditions'}
              </span>
            </a>

            {/* Build Number */}
            <div className="build-number">
              {t('homepage.version')} {buildNumber}
            </div>
          </div>
        </div>

        {/* Help Button (Bottom Right) */}
        <div className="help-button-wrapper">
          <HelpButton variant="floating" />
        </div>
      </div>
    </div>
  );
}

export default Homepage;
